import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import {BrowserRouter,Switch,Route} from "react-router-dom"
import Home from "./Home";
import Header from "./component/Header"
import Footer from "./component/Footer";
import register from "./register";
import User from "./User";

function App() {
  return (
    <BrowserRouter >
    <Header/>
    <Switch >
      
      <Route exact path="/login" component={Login}/>
      <Route exact path="/register" component={register} />
      <Route exact path="/" component={Home}/>
      <PrivateRoute exact path="/user" component={User}/>
      
      
    </Switch>
    <Footer/>
    </BrowserRouter>
      
    
  );
}

export default App;
